import 'iframe-lightbox/js/iframe-lightbox';
import LazyLoad from '@src/js/lazy-load';

[].forEach.call(document.getElementsByClassName("iframe-lightbox-link"), function (el) {
	el.lightbox = new IframeLightbox(el,{
		onClosed: function() {
			$.request('Cart::onUpdate', {
				'update': {'header/header-cart': '.header-cart'},
				'complete': function() {
					LazyLoad.update();
				}
			});
		},
	});
});
